/**
 * Client for the enquiry endpoint.
 *
 * Same origin: CloudFront routes /api/* to the Lambda function URL, so there is
 * no CORS preflight on the critical path and no API hostname baked into the bundle.
 */

const ENDPOINT = import.meta.env.VITE_CONTACT_ENDPOINT || '/api/contact';
const TIMEOUT_MS = 15000;

export class EnquiryError extends Error {
  constructor(message, { status = 0, field = null } = {}) {
    super(message);
    this.name = 'EnquiryError';
    this.status = status;
    this.field = field;
  }
}

export async function sendEnquiry(payload) {
  const abort = new AbortController();
  const timer = setTimeout(() => abort.abort(), TIMEOUT_MS);

  let response;
  try {
    response = await fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload),
      signal: abort.signal,
    });
  } catch {
    // A refused connection, a timeout and an offline device look the same here.
    throw new EnquiryError('network', { status: 0 });
  } finally {
    clearTimeout(timer);
  }

  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new EnquiryError(body.error || 'server', { status: response.status, field: body.field || null });
  }
  return body;
}
